import React from 'react';
import Footer from '../Footer';
import './ComingSoon.css';

const COMING_SOON_ITEMS = [
  {
    icon: 'fas fa-calculator',
    title: 'Azure Pricing Calculator',
    description: 'Estimate and optimise your Azure costs with an interactive pricing tool tailored for your workloads.',
  },
  {
    icon: 'fas fa-server',
    title: 'Azure Sizing Calculator',
    description: 'Right-size your Azure VMs and services based on your on-premises workload specifications.',
  },
  {
    icon: 'fas fa-tools',
    title: 'ITHelper',
    description: 'A collection of IT utilities and quick-reference tools to help engineers solve problems faster.',
  },
  {
    icon: 'fas fa-users',
    title: 'Community',
    description: 'Create an account, join the conversation — leave comments, submit your own blog posts, and connect with others in the community.',
  },
];

function ComingSoon() {
  return (
    <>
      <div className='coming-soon-container'>
        <div className='coming-soon-hero'>
          <span className='coming-soon-badge'>
            <i className='fas fa-rocket'></i> Coming Soon
          </span>
          <h1>What's Next</h1>
          <p>We're working on some exciting new tools and features. Here's a sneak peek at what's on the way.</p>
        </div>

        <div className='coming-soon-grid'>
          {COMING_SOON_ITEMS.map((item) => (
            <div key={item.title} className='coming-soon-card'>
              <div className='coming-soon-card-icon'>
                <i className={item.icon}></i>
              </div>
              <div className='coming-soon-card-badge'>Coming Soon</div>
              <h2>{item.title}</h2>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ComingSoon;
